<template>
  <div class="ppv-filter-group">
    <div class="ppv-filter-label-row">
      <span class="ppv-filter-label">{{ $t("ppv.filters.risk_assessment") }}</span>
      <span
        class="ppv-tooltip-wrapper"
        tabindex="0"
        role="button"
        :aria-label="$t('ppv.filters.risk_assessment_tooltip')"
      >
        <v-icon class="ppv-info-icon" aria-hidden="true">
          {{ icons.mdiInformationOutline }}
        </v-icon>
        <span class="ppv-css-tooltip" role="tooltip">
          {{ $t("ppv.filters.risk_assessment_tooltip") }}
        </span>
      </span>
    </div>

    <div class="ppv-segment-track">
      <button
        v-for="option in conditionOptions"
        :key="option.value"
        class="ppv-segment-option"
        :class="{ active: selectedMode === option.value }"
        @click="onSelect(option.value)"
      >
        {{ $t(option.label) }}
      </button>
    </div>
  </div>
</template>

<script>
import icons from '@/mixins/icons'

export default {
  name: 'PpvConditionsFilter',
  mixins: [icons],
  props: {
    selectedMode: {
      type: String,
      required: true,
      validator: (v) => ['all', 'user_selected'].includes(v),
    },
    onSelect: { type: Function, required: true },
  },
  data() {
    return {
      conditionOptions: [
        { label: 'ppv.filters.risk_assessment_accepted', value: 'user_selected' },
        { label: 'ppv.filters.risk_assessment_all', value: 'all' },
      ],
    }
  },
}
</script>

<style scoped>
.ppv-filter-group {
  margin-bottom: 20px;
}

.ppv-filter-label-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
}

.ppv-filter-label {
  font-size: 11px;
  font-weight: 700;
  color: #8a96a8;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.ppv-info-icon {
  flex-shrink: 0;
  cursor: default;
  font-size: 18px !important;
  color: #a0aec0 !important;
}

.ppv-tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.ppv-css-tooltip {
  display: none;
  position: absolute;
  bottom: calc(100% + 8px);
  left: -31px;
  width: 340px;
  background-color: #1a2340;
  color: #fff;
  font-size: 13px;
  padding: 10px 14px;
  border-radius: 6px;
  line-height: 1.5;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
  white-space: normal;
}

.ppv-css-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 35px;
  border-width: 6px;
  border-style: solid;
  border-color: #1a2340 transparent transparent transparent;
}

.ppv-tooltip-wrapper:hover .ppv-css-tooltip,
.ppv-tooltip-wrapper:focus .ppv-css-tooltip,
.ppv-tooltip-wrapper:focus-within .ppv-css-tooltip {
  display: block;
}

.ppv-segment-track {
  display: inline-flex;
  background: #eaedf2;
  border-radius: 10px;
  padding: 3px;
}

.ppv-segment-option {
  padding: 6px 16px;
  border-radius: 8px;
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: #8a96a8;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.18s, color 0.18s, box-shadow 0.18s;
  line-height: 1.4;
}

.ppv-segment-option.active {
  background: #fff;
  color: #2c7a8c;
  font-weight: 700;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.10);
}

.ppv-segment-option:not(.active):hover {
  color: #4a5568;
}

@media (max-width: 600px) {
  .ppv-segment-track {
    display: flex;
    width: 100%;
  }

  .ppv-segment-option {
    flex: 1;
    padding: 6px 12px;
    white-space: normal;
    text-align: center;
  }

  .ppv-filter-group {
    position: relative;
  }

  .ppv-tooltip-wrapper {
    position: static;
  }

  .ppv-css-tooltip {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    right: 0;
    width: auto;
    max-width: none;
    min-width: auto;
    transform: none;
    text-align: center;
  }

  .ppv-css-tooltip::after {
    display: none;
  }
}
</style>
